import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { Request, Trace, Message, isInboundTraceSource } from '../models/tracer.model';

/**
 * Renders the request's "received at" timestamp for the sidebar request
 * card. format: `DD-MM-YYYY @ HH:mm:ss.SSS` (millisecond precision so
 * sub-second ordering of parallel calls is visible).
 *
 * Resolution order:
 *
 *   1. The json-api `input` message CreatedAt — the moment the request
 *      entered the gateway. Most accurate for ndc-json-api traffic.
 *   2. `request.created_at` — populated by the backend ingest path even
 *      when the json-api trace is absent (raw / sidecar-only captures).
 *      Without this fallback, those rows previously rendered as empty
 *      in the sidebar (the only signal users had that the row had a
 *      time at all was the implicit chronological order).
 *
 * Returns empty when no usable timestamp exists at all.
 */
@Pipe({
  name: 'jsonApiTraceTime',
})
export class JsonApiTraceTimePipe implements PipeTransform {
  private static readonly FORMAT = 'DD-MM-YYYY @ HH:mm:ss.SSS';

  transform(request: Request): string {
    if (!request) return '';

    const inputTrace = request.traces?.find((t: Trace) => isInboundTraceSource(t.source));
    const inputMsg = inputTrace?.messages?.find((m: Message) => m.name === 'input');
    const ts = inputMsg?.created_at ?? request.created_at;

    if (!ts) return '';
    return moment(ts).format(JsonApiTraceTimePipe.FORMAT);
  }
}
